export const BASEURL = `${process.env.VUE_APP_BACKEND_HOST}/info/${process.env.VUE_APP_MERCHANT_ID}`;

import Product, { EventInfo } from '@/api/product';
import { ScheduleSold } from '@/api/tickets';
import moment from 'moment';
import * as momd from 'moment';
import { extendMoment } from 'moment-range';
const { range } = extendMoment(momd);

function timeToMoment(day: moment.Moment, time: string): moment.Moment {
  const [h, m] = time.split(':');
  return day.clone().hour(Number(h)).minute(Number(m)).second(0);
}

export function getEvents(start: moment.Moment, end: moment.Moment,
                          prods: Product[], sold: Map<string, ScheduleSold> | null): EventInfo[] {
  const events: EventInfo[] = [];

  for (const p of prods.filter((pr) => pr.publish)) {
    const timeRange = range(start, end);
    for (const d of timeRange.by('day')) {
      for (const sc of p.schedList) {
        const s = moment(`${d.year()}-${sc.start}`, 'YYYY-MM-DD');
        const e = moment(`${d.year()}-${sc.end}`, 'YYYY-MM-DD');

        const schedRange = range(s, e);
        if (!d.within(schedRange) || !sc.selectedDays.includes(d.day())) {
          continue;
        }

        if (sc.notAvailArray.find((val) => moment(`${d.year()}-${val}`, 'YYYY-MM-DD').isSame(d, 'day'))) {
          continue;
        }

        const stock = sc.ticketsAvail;
        for (const t of sc.timeArray) {
          const startMoment = timeToMoment(d, t.startTime);
          const endMoment = timeToMoment(d, t.endTime);

          const soldkey = String(p.id) + String(startMoment.unix());
          let avail = stock;
          if (sold && sold.has(soldkey)) {
            avail = stock - sold.get(soldkey)!.qty;
          }
          events.push({
            stock,
            ...t, avail, ...p,
            start: startMoment.format('YYYY-MM-DD H:mm'),
            end: endMoment.format('YYYY-MM-DD H:mm'),
          });
        }
      }
    }
  }
  return events;
}
